import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';

import styles from './UploadBox.less';
import UploadFileInput from './UploadFileInput';
import {TranslateUtils} from 'src/js/common/utils';
import {intlShape} from 'src/js/common/utils/translate_utils';
import {ComponentBox, ComponentBoxHeaderFooter} from 'src/js/components';

const I18N = defineMessages({
  TITLE: {
    id: 'upload.title',
    defaultMessage: 'UPLOAD FILES',
    description: 'title text for upload box',
  },
  HELP: {
    id: 'upload.help',
    defaultMessage: 'This box is showing the application upload component.',
    description: 'help text for upload box',
  },
});

class UploadBox extends React.PureComponent {
  render() {
    const {
      handleUpload,
      intl,
      isUploadingCounter,
      isUploadSuccessful,
      uploadedFiles,
    } = this.props;
    return (
      <div className={styles.dlUploadBox}>
        <ComponentBoxHeaderFooter
          titleText={TranslateUtils.translate(I18N.TITLE, intl)}
          helpText={TranslateUtils.translate(I18N.HELP, intl)}
        />
        <ComponentBox>
          <div className={'dlFlexBoxContainerInContainer'}>
            <UploadFileInput
              handleUpload={handleUpload}
              isUploadingCounter={isUploadingCounter}
              isUploadSuccessful={isUploadSuccessful}
              uploadedFiles={uploadedFiles}
            />
          </div>
        </ComponentBox>
      </div>
    );
  }
}

UploadBox.displayName = 'UploadBox';

UploadBox.propTypes = {
  handleUpload: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  isUploadingCounter: PropTypes.number.isRequired,
  isUploadSuccessful: PropTypes.bool.isRequired,
  uploadedFiles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default injectIntl(UploadBox);
